'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Code": "Polaris-InlineCode__Code"
};

exports.default = styles;
